/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type EntraGroupSyncSummaryResponse,
    EntraGroupSyncSummaryResponseFromJSON,
    EntraGroupSyncSummaryResponseToJSON,
} from '../models/EntraGroupSyncSummaryResponse';
import {
    type EntraSecurityGroupResponse,
    EntraSecurityGroupResponseFromJSON,
    EntraSecurityGroupResponseToJSON,
} from '../models/EntraSecurityGroupResponse';
import {
    type PermissionEntraGroupSyncSummaryResponse,
    PermissionEntraGroupSyncSummaryResponseFromJSON,
    PermissionEntraGroupSyncSummaryResponseToJSON,
} from '../models/PermissionEntraGroupSyncSummaryResponse';
import {
    type PermissionSecurityGroupResponse,
    PermissionSecurityGroupResponseFromJSON,
    PermissionSecurityGroupResponseToJSON,
} from '../models/PermissionSecurityGroupResponse';
import {
    type RoleSecurityGroupResponse,
    RoleSecurityGroupResponseFromJSON,
    RoleSecurityGroupResponseToJSON,
} from '../models/RoleSecurityGroupResponse';
import {
    type SetPermissionSecurityGroupRequest,
    SetPermissionSecurityGroupRequestFromJSON,
    SetPermissionSecurityGroupRequestToJSON,
} from '../models/SetPermissionSecurityGroupRequest';
import {
    type SetRoleSecurityGroupRequest,
    SetRoleSecurityGroupRequestFromJSON,
    SetRoleSecurityGroupRequestToJSON,
} from '../models/SetRoleSecurityGroupRequest';

export interface ApiEntraPermissionsPermissionIdSecurityGroupGetRequest {
    permissionId: number;
}

export interface ApiEntraPermissionsPermissionIdSecurityGroupPutRequest {
    permissionId: number;
    setPermissionSecurityGroupRequest: SetPermissionSecurityGroupRequest;
}

export interface ApiEntraPermissionsPermissionIdSyncPostRequest {
    permissionId: number;
}

export interface ApiEntraRolesRoleIdSecurityGroupGetRequest {
    roleId: number;
}

export interface ApiEntraRolesRoleIdSecurityGroupPutRequest {
    roleId: number;
    setRoleSecurityGroupRequest: SetRoleSecurityGroupRequest;
}

export interface ApiEntraRolesRoleIdSyncPostRequest {
    roleId: number;
}

/**
 * 
 */
export class EntraApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiEntraPermissionsPermissionIdSecurityGroupGet without sending the request
     */
    async apiEntraPermissionsPermissionIdSecurityGroupGetRequestOpts(requestParameters: ApiEntraPermissionsPermissionIdSecurityGroupGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiEntraPermissionsPermissionIdSecurityGroupGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/entra/permissions/{permissionId}/security-group`;
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiEntraPermissionsPermissionIdSecurityGroupGetRaw(requestParameters: ApiEntraPermissionsPermissionIdSecurityGroupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSecurityGroupResponse>> {
        const requestOptions = await this.apiEntraPermissionsPermissionIdSecurityGroupGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionSecurityGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEntraPermissionsPermissionIdSecurityGroupGet(requestParameters: ApiEntraPermissionsPermissionIdSecurityGroupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSecurityGroupResponse> {
        const response = await this.apiEntraPermissionsPermissionIdSecurityGroupGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiEntraPermissionsPermissionIdSecurityGroupPut without sending the request
     */
    async apiEntraPermissionsPermissionIdSecurityGroupPutRequestOpts(requestParameters: ApiEntraPermissionsPermissionIdSecurityGroupPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiEntraPermissionsPermissionIdSecurityGroupPut().'
            );
        }

        if (requestParameters['setPermissionSecurityGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'setPermissionSecurityGroupRequest',
                'Required parameter "setPermissionSecurityGroupRequest" was null or undefined when calling apiEntraPermissionsPermissionIdSecurityGroupPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/entra/permissions/{permissionId}/security-group`;
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetPermissionSecurityGroupRequestToJSON(requestParameters['setPermissionSecurityGroupRequest']),
        };
    }

    /**
     */
    async apiEntraPermissionsPermissionIdSecurityGroupPutRaw(requestParameters: ApiEntraPermissionsPermissionIdSecurityGroupPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSecurityGroupResponse>> {
        const requestOptions = await this.apiEntraPermissionsPermissionIdSecurityGroupPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionSecurityGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEntraPermissionsPermissionIdSecurityGroupPut(requestParameters: ApiEntraPermissionsPermissionIdSecurityGroupPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSecurityGroupResponse> {
        const response = await this.apiEntraPermissionsPermissionIdSecurityGroupPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiEntraPermissionsPermissionIdSyncPost without sending the request
     */
    async apiEntraPermissionsPermissionIdSyncPostRequestOpts(requestParameters: ApiEntraPermissionsPermissionIdSyncPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiEntraPermissionsPermissionIdSyncPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/entra/permissions/{permissionId}/sync`;
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiEntraPermissionsPermissionIdSyncPostRaw(requestParameters: ApiEntraPermissionsPermissionIdSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionEntraGroupSyncSummaryResponse>> {
        const requestOptions = await this.apiEntraPermissionsPermissionIdSyncPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionEntraGroupSyncSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEntraPermissionsPermissionIdSyncPost(requestParameters: ApiEntraPermissionsPermissionIdSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionEntraGroupSyncSummaryResponse> {
        const response = await this.apiEntraPermissionsPermissionIdSyncPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiEntraRolesRoleIdSecurityGroupGet without sending the request
     */
    async apiEntraRolesRoleIdSecurityGroupGetRequestOpts(requestParameters: ApiEntraRolesRoleIdSecurityGroupGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiEntraRolesRoleIdSecurityGroupGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/entra/roles/{roleId}/security-group`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiEntraRolesRoleIdSecurityGroupGetRaw(requestParameters: ApiEntraRolesRoleIdSecurityGroupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleSecurityGroupResponse>> {
        const requestOptions = await this.apiEntraRolesRoleIdSecurityGroupGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleSecurityGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEntraRolesRoleIdSecurityGroupGet(requestParameters: ApiEntraRolesRoleIdSecurityGroupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleSecurityGroupResponse> {
        const response = await this.apiEntraRolesRoleIdSecurityGroupGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiEntraRolesRoleIdSecurityGroupPut without sending the request
     */
    async apiEntraRolesRoleIdSecurityGroupPutRequestOpts(requestParameters: ApiEntraRolesRoleIdSecurityGroupPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiEntraRolesRoleIdSecurityGroupPut().'
            );
        }

        if (requestParameters['setRoleSecurityGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'setRoleSecurityGroupRequest',
                'Required parameter "setRoleSecurityGroupRequest" was null or undefined when calling apiEntraRolesRoleIdSecurityGroupPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/entra/roles/{roleId}/security-group`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetRoleSecurityGroupRequestToJSON(requestParameters['setRoleSecurityGroupRequest']),
        };
    }

    /**
     */
    async apiEntraRolesRoleIdSecurityGroupPutRaw(requestParameters: ApiEntraRolesRoleIdSecurityGroupPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleSecurityGroupResponse>> {
        const requestOptions = await this.apiEntraRolesRoleIdSecurityGroupPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleSecurityGroupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEntraRolesRoleIdSecurityGroupPut(requestParameters: ApiEntraRolesRoleIdSecurityGroupPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleSecurityGroupResponse> {
        const response = await this.apiEntraRolesRoleIdSecurityGroupPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiEntraRolesRoleIdSyncPost without sending the request
     */
    async apiEntraRolesRoleIdSyncPostRequestOpts(requestParameters: ApiEntraRolesRoleIdSyncPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiEntraRolesRoleIdSyncPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/entra/roles/{roleId}/sync`;
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiEntraRolesRoleIdSyncPostRaw(requestParameters: ApiEntraRolesRoleIdSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EntraGroupSyncSummaryResponse>> {
        const requestOptions = await this.apiEntraRolesRoleIdSyncPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EntraGroupSyncSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiEntraRolesRoleIdSyncPost(requestParameters: ApiEntraRolesRoleIdSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EntraGroupSyncSummaryResponse> {
        const response = await this.apiEntraRolesRoleIdSyncPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiEntraSecurityGroupsGet without sending the request
     */
    async apiEntraSecurityGroupsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/entra/security-groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiEntraSecurityGroupsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EntraSecurityGroupResponse>>> {
        const requestOptions = await this.apiEntraSecurityGroupsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EntraSecurityGroupResponseFromJSON));
    }

    /**
     */
    async apiEntraSecurityGroupsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EntraSecurityGroupResponse>> {
        const response = await this.apiEntraSecurityGroupsGetRaw(initOverrides);
        return await response.value();
    }

}
